import { render, staticRenderFns } from "./SolicitationForm.vue?vue&type=template&id=badd348c&scoped=true"
import script from "./SolicitationForm.vue?vue&type=script&lang=js"
export * from "./SolicitationForm.vue?vue&type=script&lang=js"
import style0 from "./SolicitationForm.vue?vue&type=style&index=0&id=badd348c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badd348c",
  null
  
)

export default component.exports